import type { FragmentType } from 'src/gql';
import { Text } from '@savvy-kit/foundations/text';
import { graphql, unmaskFragment } from 'src/gql';

import { CashManagementIcon } from './icons/cash-management';
import { DirectIndexIcon } from './icons/direct-index';

export const NetWorthAccountProductTypeTagFragment = graphql(/* GraphQL */ `
  fragment NetWorthAccountProductTypeTag on Account {
    productType
  }
`);

export function NetWorthAccountProductTypeTag({
  accountFrag,
  iconOnly,
}: {
  readonly accountFrag: FragmentType<typeof NetWorthAccountProductTypeTagFragment>;
  readonly iconOnly?: boolean;
}) {
  const account = unmaskFragment(NetWorthAccountProductTypeTagFragment, accountFrag);
  return (
    <div className="mr-4 flex flex-row items-center gap-2">
      {account.productType === 'direct_index' && (
        <>
          <DirectIndexIcon />
          {!iconOnly && (
            <Text variant="body-sm" color="secondary">
              Direct indexing
            </Text>
          )}
        </>
      )}
      {account.productType === 'cash_management' && (
        <>
          <CashManagementIcon />
          {!iconOnly && (
            <Text variant="body-sm" color="secondary">
              Cash management
            </Text>
          )}
        </>
      )}
    </div>
  );
}
